<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("auto.supportFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.reporting") }}</div>
                <div class="feature-input">
                    <a-select v-model="featureForm.support" style="width: 100%">
                        <a-select-option value="basic-support">{{ $t("auto.basicSupport") }}</a-select-option>
                        <a-select-option value="7-24-support">{{ $t("auto.twentyFourSevenSupport") }}</a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.otherFeatures") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.softwareSupport">{{ $t("auto.softwareSupport") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.dedicatedCustomerSupport">{{ $t("auto.dedicatedCustomerSupport") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportWhatsappBusinessSetup">{{ $t("auto.whatsappBusinessSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportFacebookSetup">{{ $t("auto.facebookSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportInstagramSetup">{{ $t("auto.instagramSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportChatbotSetup">{{ $t("auto.chatbotSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportAISetup">{{ $t("auto.aiSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportAutomationSetup">{{ $t("auto.automationSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportSpecialPanelTraining">{{ $t("auto.specialPanelTraining") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportConsultancy">{{ $t("auto.consultancy") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportIntegrationSetup">{{ $t("auto.integrationSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportStrategyPlanning">{{ $t("auto.strategyPlanning") }}</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";
export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            support: null,
            softwareSupport: false,
            dedicatedCustomerSupport: false,
            supportWhatsappBusinessSetup: false,
            supportFacebookSetup: false,
            supportInstagramSetup: false,
            supportChatbotSetup: false,
            supportAISetup: false,
            supportAutomationSetup: false,
            supportSpecialPanelTraining: false,
            supportConsultancy: false,
            supportIntegrationSetup: false,
            supportStrategyPlanning: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.SUPPORT);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.SUPPORT, ...this.featureForm };
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.SUPPORT);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
